import React, {useEffect, useRef, useState} from 'react';

// 이미지 임포트 (실제 이미지 경로로 변경 필요)
import stores from '../../../assets/images/about/section_02_subsection_07_item_01.png';

const AboutSubSection0205: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 섹션이 화면에 보일 때만 애니메이션 적용
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          // 섹션이 화면에서 벗어났을 때
          setIsVisible(false);
        }
      },
      {
        threshold: window.innerWidth <= 1024 ? 0.08 : 0.2, // 섹션이 20% 이상 보일 때 트리거 // 섹션이 20% 이상 보일 때 트리거
        rootMargin: '-50px' // 뷰포트 경계에서 50px 안쪽에서 트리거
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} className={`container text-black pt-[105px] pb-[70px] transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="hidden lg:block mx-auto">
        {/* 메인 콘텐츠 - 왼쪽 이미지, 오른쪽 텍스트 */}
        <div className="flex items-center justify-between lg:gap-8 xl:gap-16 2xl:gap-32">
          {/* 오른쪽: 텍스트 정보 */}
          <div className="w-1/2 2xl:w-2/5">
            {/* 섹션 제목 */}
            <p className="text-xl font-semibold mb-[72px]">
              Global Trade
            </p>
            <p className="text-40 leading-[1.4] font-bold mb-[72px]">
              K-뷰티를 중심으로<br/>
              글로벌 시장에 수출을 전개합니다
            </p>
            <p className="text-xl font-normal leading-[1.6]">
              중국, 동남아, 유럽 등 해외 글로벌 시장에 제품을 수출하고 있습니다.<br/>
              현지 유통망 및 인증 절차 기반의 국가별 맞춤 전략으로 글로벌 뷰티 시장에 진출하고 있습니다.
            </p>
          </div>

          {/* 왼쪽: 이미지 */}
          <div className="w-1/2 2xl:w-2/5">
            <img
              src={stores}
              alt="브랜드 이미지"
              className="w-full max-w-[728px] object-cover rounded-[5px]"
            />
          </div>
        </div>
      </div>
      <div className="lg:hidden mx-auto">
        {/* 메인 콘텐츠 - 왼쪽 텍스트, 오른쪽 이미지 */}
        <div className="flex flex-col items-center justify-center">
          {/* 왼쪽: 통계 정보 */}
          <p className="text-2xl md:text-4xl font-semibold mb-[30px] md:mb-[50px]">
            Global Trade
          </p>
          <span className="text-4xl md:text-6xl leading-[1.4] font-bold md:mb-4">
              K-뷰티를 중심으로
          </span>
          <span className="text-4xl md:text-6xl leading-[1.4] font-bold">
              글로벌 시장에 수출을 전개합니다
          </span>

          <img
            src={stores}
            alt="폰뷰 앱 화면"
            className="w-4/6 h-auto py-8 md:py-14"
          />

          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            중국, 동남아, 유럽 등 해외 글로벌 시장에</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            제품을 수출하고 있습니다.</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            현지 유통망 및 인증 절차 기반의 국가별 맞춤 전략으로</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            글로벌 뷰티 시장에 진출하고 있습니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutSubSection0205;